/* unplugin-vue-components disabled */import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"

import "./list.vue?vue&type=style&index=0&id=505071e5&lang=scss&scoped=true"
import "./list.vue?vue&type=style&index=1&id=505071e5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505071e5"]])

export default __exports__